/**
 * 预览子组件-会员推荐组件
 * @author chenqunfeng
 * @since 18/06/11
 */

import './vip-recommend.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Stat from '@fe/common/lib/stat';
import { sendStat } from 'utils/common';
import { showRabbitBrandInfo } from 'utils/user';
import VARIABLE from 'constants/variable.json5';
import { isModuleHidden } from 'utils/hidden-modules';

class PreviewVipRecommend extends Component {
  static propTypes = {
    data: PropTypes.object,
    userInfo: PropTypes.object,
  };

  // 跳转到企业服务页面
  jumpToVip() {
    const { id } = this.props.data;

    window.open(`${window.RPCONFIG.mainHost}/service/`);

    sendStat('RP_STORE', '企业服务页点击', '点击量', Stat.ACTION_CLICK, {
      id: 'web_mobanmarket_moban_qiye_click',
      tplid: id,
    });
  }

  render() {
    const { data, userInfo } = this.props;
    const { tplFreeLimit, category, pluginPlayWayTypes } = data;
    const { organizationId } = userInfo;
    // 免费作品,企业专区作品,我的模版作品,企业用户,tplFreeLimit === 1下的嬴销云用户无需提示
    if (
      // 企业专区作品
      category === VARIABLE.ENTERPRISE ||
      // 我的模版作品
      category === VARIABLE.MY_TPL ||
      // 嬴销云用户
      (tplFreeLimit === 1 && organizationId) ||
      //所有用户，包括游客暂时都是异常，玩法
      // 企业用户
      //organizeId ||
      //玩法目前是按照会员开放
      pluginPlayWayTypes.length
    ) {
      return null;
    }

    // 是否隐藏 免费模板券全场通用，立即领取
    const isVipGetFreeTemplateHidden = isModuleHidden('vip-get-free-template');
    return (
      <>
        {showRabbitBrandInfo() && !isVipGetFreeTemplateHidden ? (
          <div className="s-preview-vip-recommend">
            <a
              className="s-preview-vip-recommend-tip"
              onClick={this.jumpToVip.bind(this)}>
              {'创意云会员模板免费用 >>'}
            </a>
          </div>
        ) : null}
      </>
    );
  }
}

export default PreviewVipRecommend;
